import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC033_Request,
  IAPI_FAC033_Response,
} from "../../../type/apiType";

/**
 * 廃止・休止・経営移管施設選択表示API
 * @returns httpIAPI_FAC033
 */
const httpIAPI_FAC033 = async (
  param: IAPI_FAC033_Request
): Promise<IAPI_FAC033_Response> => {
  let res = await http.post(ApiUrl.API_FAC033, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_FAC033 };
